<template>
	<section class="page form_wrap pt-5 pb-5">
		<h2 class="mb-5 text-white text-center">contact with me</h2>
		<contacts />
	</section>
</template>

<script>
import contacts from '../components/Form'
export default {
	components: {
		contacts
	},
	data () {
		return {
			id: 3,
		}
	},
	methods: {
		onClickChild () {
			this.$emit('clicked', {
				page_id: this.id,
				next_page: false,
				prev_page: '/portfolio'
			})
		}
	},
	mounted() {
		this.$nextTick(function() {
			this.onClickChild()
		})
	},
}
</script>



// WEBPACK FOOTER //
// src/pages/form.vue